import { createFileRoute } from '@tanstack/react-router';
import { MessageJobsPage } from '@/features/messaging/pages/message-jobs-page';

export const Route = createFileRoute('/_app/messages/jobs')({ component: MessageJobsPage });
